import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SchemaCtx = createContext({ factories: {}, resources: {} });

export function SchemaProvider({ children }) {
  const [schema, setSchema] = useState({ factories: {}, resources: {} });

  const refreshSchema = async () => {
    try {
      const { data } = await api.get("/schema");
      setSchema(data);
    } catch {
      setSchema({ factories: {}, resources: {} });
    }
  };

  useEffect(() => {
    refreshSchema();
  }, []);

  return <SchemaCtx.Provider value={{ ...schema, refreshSchema }}>{children}</SchemaCtx.Provider>;
}

export const useSchema = () => useContext(SchemaCtx);
